import { LayoutGridElement } from 'components/Layout/Grid';
import { WithChildren } from 'types';

export const SectionWithoutBorderedTile = ({ children }: WithChildren) => {
  return (
    <LayoutGridElement gridColumn="5/ span 12">{children}</LayoutGridElement>
  );
};
